import { composeURL } from 'src/core/utils/functions'

export const disableSimulation = () => {
  if (typeof sessionStorage === 'undefined') {
    return
  }
  sessionStorage.clear()
  window.location.href = composeURL('/')
}
